// extracted by mini-css-extract-plugin
export var select = "_qs-0";